module.exports = __webpack_public_path__ + "img/binner-4.89b57adb.jpg";